import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { AppBar, Avatar, Button, Toolbar, Typography } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import decode from 'jwt-decode'
import useStyles from './styles.js'

// import memoriesLogo from '../../images/1453176-200.png'
// import memoriesText from '../../images/blogtown-low-resolution-logo-color-on-transparent-background.png'

import memoriesLogo from '../../images/volunteer.png'

import memoriesText from '../../images/picturetopeople.org-cbc96d50fefdf29161ed13f76dca06adcefd23c1e6b0748706.png'

const Navbar = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))

  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const token = user?.token

    if (token) {
      const decodedToken = decode(token)

      if (decodedToken.exp * 1000 < new Date().getTime()) handleLogout()
    }

    setUser(JSON.parse(localStorage.getItem('profile')))
  }, [location])

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' })

    history.push('/')
    setUser(null)
  }

  return (
    
    // <AppBar className={classes.appBar} position="static" color="inherit">
      

    //   <Link to="/" className={classes.brandContainer}>
    //   <img src={memoriesText} alt="icon" height="75px" />

    //     <img
    //       className={classes.image}
    //       src={memoriesLogo}
    //       alt="memories"
    //       height="70px"
    //     />
    //   </Link>
      
    //   <div className={classes.ourMissionButtonContainer}>
    //     <Button component={Link} to="/mission" color="inherit" className={classes.ourMissionButton}>
    //       Our Mission
    //     </Button>
    //   </div>

    //   <Toolbar className={classes.toolbar}>
    //     {user ? (
    //       <div className={classes.profile}>
           
           
    //         {/* <Avatar
    //           className={classes.purple}
    //           alt={user.result.name}
    //           src={user.result?.picture}
    //         >
    //           {user.result?.name.charAt(0)}
    //         </Avatar> */}
            
           

    //         <Typography className={classes.userName} variant="h6">
    //           {user.result?.name}
    //         </Typography>
    //         <Button
    //           variant="contained"
    //           className={classes.logout}
    //           color="secondary"
    //           onClick={handleLogout}
    //         >
    //           Logout
    //         </Button>
    //       </div>
    //     ) : (
    //       <Button
    //         component={Link}
    //         to="/auth"
    //         variant="contained"
    //         color="primary"
    //       >
    //         Sign In
    //       </Button>
    //     )}
    //   </Toolbar>
    // </AppBar>
<AppBar className={classes.appBar} position="static" color="inherit">
      <Link to="/" className={classes.brandContainer}>
        <img src={memoriesText} alt="icon" height="75px" />
        <img className={classes.image} src={memoriesLogo} alt="memories" height="70px" />
      </Link>

      <Toolbar className={classes.toolbar}>
        {user ? (
          <div className={classes.profile}>
            <Typography className={classes.userName} variant="h6">
              {user.result?.name}
            </Typography>
            <Button
              variant="contained"
              className={classes.logout}
              color="secondary"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </div>
        ) : (
          <Button
            component={Link}
            to="/auth"
            variant="contained"
            color="primary"
            className={classes.signInButton} // Add this class
            style={{ marginRight: '20px' }}

          >
            Sign In
          </Button>
        )}

        <div className={classes.ourMissionButtonContainer}>
          <Button component={Link} 
                      style={{ whiteSpace: 'nowrap' }} // Prevent the button from breaking into multiple lines

          to="/mission" color="inherit" className={classes.ourMissionButton}>
           
            Our Mission
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  )
}

export default Navbar
